import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // Mostra loading enquanto verifica autenticação
    return (
      <div className="preloader" style={{ display: 'flex' }}>
        <svg className="circular" viewBox="25 25 50 50">
          <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10" />
        </svg>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redireciona para login, salvando a URL de destino
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
